import React from 'react'

export interface IStepProps {
	title: string
	icon: React.ReactNode

	children: React.ReactNode
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ContentStep = (props: IStepProps): React.ReactElement => <></>
